export const isDev = typeof __DEV__ !== 'undefined' ? __DEV__ : true
